// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { JobOrderHistDetail } from './job-order-hist-detail';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class JobOrderHistDetailReceipt extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Guid FK jobOrderHistDetail */
  jobOrderHistDetailId!: string;
  /** Int32 */
  receiptQty!: number;
  /** DateTimeOffset */
  receiptTs!: Date;
  /** FK jobOrderHistDetailId */
  jobOrderHistDetail!: JobOrderHistDetail;
}

